import { isPatientUser } from 'utils/common'

// Value prop messaging is permanent behavior for DTC self-booking clients
// (fc-025 A/B test concluded "do no harm", rollout approved by Maya Elliano).
// ThriveSupport/COE and other non-patient users remain excluded (THRIV-13817).
const useIsValuePropShown = (): boolean => isPatientUser()

export default useIsValuePropShown
